module.exports = __webpack_public_path__ + "static/sport/logo.c56ba55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/logo.png
// module id = cEO6
// module chunks = 0